// extracted by mini-css-extract-plugin
export default {"root":"ListStatics_root__4oiT7","item":"ListStatics_item__e35-p"};